import { FloatButton as AntdFloatButton } from "@empglabs/backoffice-ui-kit"

const FloatButton = props => {
  return <AntdFloatButton {...props} />
}

export default FloatButton
